<script>
  import {
    customersComputed,
    termMethods,
  } from '@state/helpers'
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect,
    },
    props: {
      formError: {
        type: Object,
        required: true
      },
      fromData: {
        type: Object,
        required: true
      },
      nameLabel: {
        type: String,
        default: 'Registered Business Name',
      },
      applicableTermTypes: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        allTerms: [],
      }
    },
    computed: {
      ...customersComputed,
    },
    async created(){
      const params = {
        type: this.applicableTermTypes,
        fields: 'id,name,duration,type,description'
      }
      const response = await this.getTerms( params)
      this.allTerms = response.data.data
    },
    methods: {
      ...termMethods,
    }
  };
</script>
<template>
  <div class="tw-pt-2">
    <div class="md:tw-flex-row tw-flex tw-flex-col tw-justify-between">
      <div class="tw-w-full md:tw-w-1/2 md:tw-mr-3">
        <div :class="['form-group tw-mb-2', { 'is-invalid': formError.name }]">
          <label>{{ nameLabel }}*</label>
          <input
            v-model="fromData.name"
            type="text"
            class="form-control"
            placeholder="My favourite new customer's name goes here." />
          <p v-if="formError && formError.name" class="text-danger">{{ formError.name }}</p>
        </div>
      </div>
      <div class="tw-w-full md:tw-w-1/2 md:tw-ml-3">
        <div :class="['form-group tw-mb-2', { 'is-invalid': formError.term_id }]">
          <label>Payment Terms*</label>
          <Multiselect
            v-model="fromData.term"
            track-by="id"
            label="name"
            :multiple="false"
            :class="{
              'scrollable': allTerms.length > 7,
            }"
            :options="allTerms"
            :internal-search="true"
            :disabled="false"
            placeholder="Select Payment Terms"
          />
          <p v-if="formError && formError.term_id" class="text-danger">{{ formError.term_id }}</p>
        </div>
      </div>
    </div>
    <div class="md:tw-flex-row tw-flex tw-flex-col tw-justify-between">
      <div class="tw-w-full md:tw-w-1/2 md:tw-mr-3">
        <div :class="['form-group tw-mb-2 md:tw-mb-u', { 'is-invalid': formError.abn }]">
          <label class="label-control">ABN</label>
          <input
            v-model="fromData.abn"
            v-mask="'###########'"
            type="text"
            class="form-control"
            placeholder=" E.g. 01 001 000 001" />
          <p v-if="formError && formError.abn" class="text-danger">{{ formError.abn }}</p>
        </div>
      </div>
      <div class="tw-w-full md:tw-w-1/2 md:tw-ml-3">
        <div :class="['form-group tw-mb-u', { 'is-invalid': formError.acn }]">
          <label class="label-control">ACN</label>
          <input
            v-model="fromData.acn"
            v-mask="'#########'"
            type="text"
            class="form-control"
            placeholder=" E.g. 001 000 001" />
          <p v-if="formError && formError.acn" class="text-danger">{{ formError.acn }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
